<div class="page-wraper">
    <div class="page-title-block common-head">
        <div class="title-block-left">
            <h1 class="title h3">User & Access</h1>
        </div>
        <div class="title-block-right button-group">
            <mat-form-field class="fixed-label label-none icon-form-before w-300" floatLabel="always">
                <mat-label>Search</mat-label>
                <input matInput placeholder="Search" autocomplete="off" (keyup)="applyFilter($event)" type="text"
                    maxlength="50" autocomplete="off">
                <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                </span>
            </mat-form-field>
            <button mat-button mat-flat-button color="primary" class="button-default" [matMenuTriggerFor]="addUserMenu"
                [ngClass]="{'disable-button': (acl?.hasUserAdd != true || (userAccessActions?.addclient == 0 && userAccessActions?.addteammember == 0) || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress))}"
                [disabled]="(acl?.hasUserAdd != true || (userAccessActions?.addclient == 0 && userAccessActions?.addteammember == 0) ||  (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress))">
                <span class="flexbox-row gap-8">
                    <span class="button-label">Add User</span>
                    <i class="fa-regular fa-angle-down"></i>
                </span>
            </button>
            <mat-menu #addUserMenu="matMenu" #beforeMenu="matMenu" xPosition="before">
                <button mat-menu-item
                    (click)="(acl?.hasTeamMemberAdd != true || userAccessActions?.addteammember == 0)!= true?addTeamMember():''"
                    [disabled]="acl?.hasTeamMemberAdd != true || userAccessActions?.addteammember == 0">
                    Add Team
                    Member
                </button>
                <button mat-menu-item
                    (click)="(acl?.hasClientAdd != true || userAccessActions?.addclient == 0) != true ? addClient():''"
                    [disabled]="acl?.hasClientAdd != true || userAccessActions?.addclient == 0">Add
                    Client
                </button>
            </mat-menu>
        </div>
    </div>
    <div class="content-block-main gap-20">
        <div class="cards-group gap-20" style="width:900px;max-width:100%;">
            <div class="card">
                <div class="card-body user-acc-card">
                    <h6 class="sub-title">Active Firm Member(s)</h6>
                    <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{countsFromApi()[0]?.paid}}</h2>
                </div>
            </div>
            <div class="card">
                <div class="card-body user-acc-card">
                    <h6 class="sub-title">Client(s)</h6>
                    <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{ clientsCount() }}</h2>
                </div>
            </div>
            <div class="card">
                <div class="card-body user-acc-card">
                    <h6 class="sub-title">Total</h6>
                    <h2 appSpin [spinnerConfig]='spinnerConfig()'>{{ totalCount() }}</h2>
                </div>
            </div>
        </div>

        <div class="user-access-tab flex-1 overflow-auto">
            <mat-tab-group class="h-100" (selectedIndexChange)="onChangeTab($event)" animationDuration="0ms">
                <mat-tab label="Firm">
                    <div class="card table-responsive" appSpin [spinnerConfig]='spinnerConfigTab()'>
                        <table mat-table #teamMembersSort="matSort" [dataSource]="teamMembers"
                            [trackBy]="trackTeamAccessDetails" matSort (matSortChange)="sortData($event)"
                            matSortDirection="asc" matSortDisableClear class="mat-sort customized-sort table-countable">
                            <!-- Title Column -->
                            <ng-container matColumnDef="title">
                                <th mat-header-cell *matHeaderCellDef class="col-title" style="max-width:130px;" mat-sort-header>Title</th>
                                <td mat-cell *matCellDef="let element" title="{{element.title}}" class="col-title" style="max-width:130px;">
                                    <span class="text-ellipse" [ngClass]="{'col-disabled':element.statusid == 1}">{{
                                        element.title }}</span>
                                </td>
                            </ng-container>
                            <!--Full Name Column -->
                            <ng-container matColumnDef="fullname">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:250px;">Name</th>
                                <td mat-cell *matCellDef="let element" title="{{element.fullname}}"
                                    style="max-width:250px;">
                                    <span class="text-ellipse" [ngClass]="{'col-disabled':element.statusid == 1}">{{
                                        element.fullname }}</span>
                                </td>
                            </ng-container>
                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef class="col-email">Email</th>
                                <td mat-cell *matCellDef="let element" title="{{element.email}}" class="col-email">
                                    <a href="mailto:{{element.email}}" class="text-link text-ellipse"
                                        [ngClass]="{'col-disabled':element.statusid == 1}">{{ element.email }}</a>
                                </td>
                            </ng-container>

                            <!-- Access Type Column -->
                            <ng-container matColumnDef="useraccessname">
                                <th mat-header-cell *matHeaderCellDef class="col-accesstype" mat-sort-header>Access Type
                                </th>
                                <td mat-cell *matCellDef="let element" class="col-accesstype">
                                    <ng-container *ngIf="!element.isEdit">
                                        <span class="text-ellipse" title="{{element.useraccessname}}"
                                            [ngClass]="{'col-disabled':element.statusid == 1}">{{ element.useraccessname
                                            }}</span>
                                    </ng-container>
                                </td>
                            </ng-container>
                            <!-- Last Logged In Column -->
                            <ng-container matColumnDef="lastloggedin">
                                <th mat-header-cell *matHeaderCellDef class="col-last">Last Logged In</th>
                                <td mat-cell *matCellDef="let element" class="col-last">
                                    <span class="text-ellipse" title="{{element.lastloginedin | timeago: 'TB'}}"
                                        [ngClass]="{'col-disabled':element.statusid == 1}">{{ element.lastloginedin |
                                        timeago: 'TB' }}</span>
                                </td>
                            </ng-container>
                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="col-status" mat-sort-header>
                                    <div class="flex-box">Status</div>
                                </th>
                                <td mat-cell *matCellDef="let element" title="{{element.status}}" class="col-status">
                                    <span class="badge badge-pills badge-small"
                                        [ngClass]="{'archived': element.statusid == 1, 'active': element.statusid == 0}">{{
                                        element.status }}</span>
                                </td>
                            </ng-container>
                            <!-- Actions Column -->
                            <ng-container matColumnDef="actions" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef class="text-center pe-2"
                                    style="width:105px;max-width:105px;">Actions
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end pe-2"
                                    style="width:105px;max-width:105px;">
                                    <div class="table-button-group">
                                        <button mat-button class="button-text"
                                            title="{{element.statusid == 0 ? 'Remove' : 'Grant'}}"
                                            [matMenuTriggerFor]="teamAccess" [disabled]="element.isstatusedit==0">
                                            <i class="fa-regular fa-user-minus"></i>
                                        </button>
                                        <mat-menu #teamAccess="matMenu" xPosition="before" overlapTrigger="false">
                                            <button (click)="saveTeamUserStatus(element.useraccountid, false)"
                                                mat-menu-item *ngIf="element.statusid == 0">
                                                <span>Remove Access</span>
                                            </button>
                                            <ng-container *ngIf="element.statusid == 1">
                                                <button (click)="saveTeamUserStatus(element.useraccountid, true)"
                                                    mat-menu-item>
                                                    <span>Grant Access</span>
                                                </button>
                                            </ng-container>
                                        </mat-menu>
                                        <button mat-button class="button-text" title="Edit"
                                            (click)="(acl?.hasTeamMemberEdit != true|| (loggedInUserDetails.useraccesstypeid == 3 && acl?.hasTeamMemberEdit == true && element.isadminedit == 0) || userAccessActions.modifyteammember == 0 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress)) != true ? updateMember(element) :''"
                                            [disabled]="acl?.hasTeamMemberEdit != true|| (loggedInUserDetails.useraccesstypeid == 3 && acl?.hasTeamMemberEdit == true && element.isadminedit == 0) || userAccessActions.modifyteammember == 0 || (firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress)">
                                            <i class="fa-regular fa-pen"></i>
                                        </button>
                                        <button mat-button class="button-text" title="Delete" (click)="(acl?.hasTeamMemberDelete != true ||
                  element.useraccountid === loggedInUserDetails.useracctid && loggedInUserDetails.useraccesstypeid === 2 ||
                  (loggedInUserDetails.useraccesstypeid == 3 && acl?.hasTeamMemberDelete == true && element.isadmindelete == 0) ||
                  userAccessActions.deleteteammember == 0 || element.isstatusedit==0)!= true? deleteDialog(element):''"
                                            [disabled]="acl?.hasTeamMemberDelete != true ||
                  element.useraccountid === loggedInUserDetails.useracctid && loggedInUserDetails.useraccesstypeid === 2 ||
                  (loggedInUserDetails.useraccesstypeid == 3 && acl?.hasTeamMemberDelete == true && element.isadmindelete == 0) ||
                  userAccessActions.deleteteammember == 0 || element.isstatusedit==0">
                                            <i class="fa-regular fa-trash-can"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsTeams; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsTeams;"></tr>
                        </table>
                    </div>
                </mat-tab>

                <mat-tab label="Client">
                    <div class="card table-responsive">
                        <table #clientMembersSort="matSort" mat-table [dataSource]="datasource"
                            [trackBy]="trackClientAccessDetails" [trackBy]="trackByClientFirm" matSort
                            matSortDirection="asc" matSortDisableClear
                            class="mat-sort customized-sort table-countable cell-p-8">

                            <!--Full Name Column -->
                            <ng-container matColumnDef="entityName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:250px;">Name</th>
                                <td mat-cell *matCellDef="let element" title="{{element.entityName}}"
                                    style="max-width:250px;">
                                    <span class="text-ellipse" [ngClass]="{'col-disabled':element.statusid == 0}">{{
                                        element.entityName }}</span>
                                </td>
                            </ng-container>
                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef class="col-email">Email</th>
                                <td mat-cell *matCellDef="let element" title="{{element.email}}" class="col-email">
                                    <a href="mailto:{{element.email}}" class="text-ellipse text-link"
                                        [ngClass]="{'col-disabled':element.statusid == 0}">{{ element.email }}</a>
                                </td>
                            </ng-container>


                            <!-- Last Logged In Column -->
                            <ng-container matColumnDef="lastloggedin">
                                <th mat-header-cell *matHeaderCellDef class="col-last"> Last Logged In</th>
                                <td mat-cell *matCellDef="let element" title="{{element.lastloginedin | timeago: 'TB'}}"
                                    class="col-last">
                                    <span class="text-ellipse" [ngClass]="{'col-disabled': element.statusid == 0}">
                                        {{ element.lastloginedin ? (element.lastloginedin | timeago: 'TB') : '-'
                                        }}</span>
                                </td>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="col-status" mat-sort-header>
                                    <div class="flex-box">Status</div>
                                </th>
                                <td mat-cell *matCellDef="let element"
                                    [title]="element.isArchived ? 'Archived' : 'Active'" class="col-status">
                                    <span class="badge badge-pills badge-small"
                                        [ngClass]="element.isArchived ? 'archived' : 'active'">{{ element.isArchived ?
                                        'Archived' : 'Active' }}</span>
                                </td>
                            </ng-container>


                            <!-- Actions Column -->
                            <ng-container matColumnDef="actions" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef class="text-center pe-2"
                                    style="width:105px;max-width:105px;">Actions
                                </th>
                                <td mat-cell *matCellDef="let element" class="text-end pe-2"
                                    style="width:105px;max-width:105px;">
                                    <div class="table-button-group">
                                        <button mat-button title="{{ !element.isArchived ? 'Archive' : 'Un-Archive'}}"
                                            class="button-text" [matMenuTriggerFor]="teamClientAccess">
                                            <i class="fa-regular"
                                                [ngClass]="!element.isArchived ? 'fa-user-plus' : 'fa-user-minus'"></i>
                                        </button>
                                        <mat-menu #teamClientAccess="matMenu" xPosition="before" overlapTrigger="false">
                                            @if(!element.isArchived){
                                            <button (click)="showArchiveClientDecisionDialog(element, true)"
                                                mat-menu-item>
                                                <span>Archive Client</span>
                                            </button>
                                            } @else {
                                            <button (click)="showArchiveClientDecisionDialog(element, false)"
                                                mat-menu-item>
                                                <span>Un-Archive Client</span>
                                            </button>
                                            }
                                        </mat-menu>
                                        <button mat-button title="Edit" class="button-text"
                                            (click)="(acl.hasClientEdit && isFirmHealthyAndHasEditAccess) ? updateClient(element) : ''"
                                            [disabled]="!(acl.hasClientEdit && isFirmHealthyAndHasEditAccess)">
                                            <i class="fa-regular fa-pen"></i>
                                        </button>
                                        <button mat-button title="Delete" class="button-text"
                                            (click)="(acl?.hasClientDelete != true  || element.useraccountid === loggedInUserDetails.useracctid && acl?.accessLevelId === 2) != true ? deleteClientWarning(element):''"
                                            [disabled]="acl?.hasClientDelete != true  || element.useraccountid === loggedInUserDetails.useracctid && acl?.accessLevelId === 2">
                                            <i class="fa-regular fa-trash-can"></i>
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsClients; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsClients;"></tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>

            @if(noFirmTeamAccessDetailsFound) {
            <div class="no-data-found">
                <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                <h6>No Records Found</h6>
            </div>
            }
        </div>

    </div>
</div>

<ng-template #deleteClientDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-trash-can text-error"></i>
            </span>
            <h4 class="title">Delete Client</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>{{ bodyMessage }}</p>
            <p>{{ warningMessage }}</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">Cancel
            </button>
            <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true"
                (click)="deleteClient()">Delete
            </button>
        </div>
    </div>
</ng-template>
<!-- ensure engagement must be deleted before deleting client -->
<ng-template #alertDeleteClientDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Delete Client</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>All open engagements associated with this client needs to be deleted before deleting the client data.</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true">Ok
            </button>
        </div>
    </div>
</ng-template>

<ng-template #alertUnArchiveClientDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Un-archive Client</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content align-items-center">
            <p>You are trying to un-archive the client `{{ clientName }}`.</p>
            <p>{{ warningMessage }}</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true"
                (click)="changeClientArchiveStatus(false)">Yes
            </button>
        </div>
    </div>
</ng-template>

<!-- ensure engagement must be deleted before deleting client -->
<ng-template #alertArchiveClientDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
            <span class="badge badge-warning badge-circle icon-bordered-warning">
                <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            </span>
            <h4 class="title">Archive Client</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>There are completed/archived engagements under this client. Deleting the client will remove the
                engagement data
                permanently.</p>
            <p>Do you wish to Archive the client instead of deleting it permanently?</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]="true"
                (click)="changeClientArchiveStatus(true)">Yes
            </button>
        </div>
    </div>
</ng-template>